import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: ""
}, "Не выбрано", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";
import { ISubdivision } from "@/@types/ISubdivision";


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartmentModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);
const subdivisions = ref<ISubdivision[]>([]);
const state = reactive({
    title: '',
    btn: '',
    name: '',
    subdivisionId: '',
    visibleErrors: false,
    loader: false,
});

const isNameError = computed(() => !state.name.length);
const isSubdivisionIdError = computed(() => !Number(state.subdivisionId));

onMounted((() => {
    api.department.getSubdivisions().then(r => {
        subdivisions.value = r.data;
    });
    if (modal.data.type !== 'add' && modal.data.department) {
        state.title = 'Редактирование подразделения';
        state.subdivisionId = modal.data?.department?.subdivisionId;
        state.name = modal.data?.department?.name;
    } else {
        state.title = 'Создание подразделения';
    }
}));

function send() {
    state.loader = true;
    if (isNameError.value || isSubdivisionIdError.value) {
        state.visibleErrors = true
        return;
    }
    state.visibleErrors = false;
    if (modal.data.type === 'add') {
        api.department.create({
            name: state.name,
            subdivisionId: state.subdivisionId,
        }).then(modal.ok);
        state.loader = false;
        return;
    }
    api.department.update(modal.data.department.id, {
        name: state.name,
        subdivisionId: state.subdivisionId,
    }).then(modal.ok);
    state.loader = false;
}


return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-sm",
    title: state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите название",
              label: "Название",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.name) = $event)),
                  "is-invalid": state.visibleErrors && isNameError.value,
                  placeholder: "Название"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Подразделение не указано",
              label: "Подразделение"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-select mt-2", { 'is-invalid': state.visibleErrors && isSubdivisionIdError.value }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.subdivisionId) = $event))
                }, [
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subdivisions.value, (subdivision) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: subdivision.id,
                      value: subdivision.id
                    }, _toDisplayString(subdivision.name), 9, _hoisted_5))
                  }), 128))
                ], 2), [
                  [_vModelSelect, state.subdivisionId]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})